module.exports = __webpack_public_path__ + "static/img/customer_icon.cec09463.svg";